import { render, staticRenderFns } from "./TimerWrapper.vue?vue&type=template&id=ed12ef70"
import script from "./TimerWrapper.vue?vue&type=script&lang=js"
export * from "./TimerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports